import Table from "/src/components/table";
import capitalizeFirstLetter from "../../../../../utils/capitalizeFirstLetter";
import { useNavigate } from "react-router-dom";
import botService from "/src/features/bot/services/botService";
import { PageTable, Header } from "/src/layouts/page/index";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";

function AnalyticsTable() {
    const navigate = useNavigate();

    const { getBots, getBotsShared } = botService;

    const cells = [
        {
            column: "Name",
            name: "name",
            show: (value) => capitalizeFirstLetter(value),
        },
        {
            column: "Language",
            name: "language.slug",
            show: (value) => <span className={"flag-icon flag-icon-" + value.toLowerCase()} />,
        },
    ];

    const getAllBots = async (data) => {
        const result = await Promise.all([getBots(data), getBotsShared(data)]);
        if (result[0][1] != null || result[1][1] != null) {
            return [null, result[0][1] != null ? result[0][1] : result[1][1]];
        }
        const mergeData = result[0][0].concat(result[1][0]);
        mergeData.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });

        return [mergeData, null];
    };

    const onClickView = ({ row, updateRow, getIndex }) => {
        navigate(urlWithRoutingCompany("/supervision/analytics/" + row.name));
    };

    const actions = [{ className: "fas fa-chart-pie blue", style: {}, onClick: onClickView }];

    const buttons = [];

    const filterPostRequest = (value) => value.conversation_storage_time != 0;

    return (
        <PageTable>
            <Header title="Analytics List"></Header>
            <Table
                name="analytic"
                cells={cells}
                api={getAllBots}
                withPagination={false}
                actions={actions}
                buttons={buttons}
                filterPostRequest={filterPostRequest}></Table>
        </PageTable>
    );
}

export default AnalyticsTable;
